export const TitleConfig = ({
  title,
  className
}: {
  title: string;
  className?: string;
}) => {
  return (
    <div className={`d-flex my-3 ${className ? className : ""}`}>{title}</div>
  );
};
